module.exports = __webpack_public_path__ + "a1a86419e5f07ed965ae9504d93f283f.svg";